import React from 'react';
import T from 'prop-types';
import cx from 'classnames';
import Button from '../../Buttons/Button';

const MenuItemGhostButton = ({
  value,
  text = 'Only',
  className = '',
  onClick,
}) => {
  const handleClick = (event) => {
    event.stopPropagation();
    onClick(value);
  };

  return (
    <Button
      className={cx('menu-item-ghost-button', className)}
      onClick={handleClick}
    >
      {text}
    </Button>
  );
};

MenuItemGhostButton.propTypes = {
  text: T.string,
  value: T.any,
  className: T.string,
  onClick: T.func.isRequired,
};

export default MenuItemGhostButton;
